export const OPENED = 'OPENED';
export const ONGOING = 'ONGOING';
export const COMPLETED = 'COMPLETED';
export const CANCELED = 'CANCELED';
export const COULD_NOT_CONNECT = 'COULD_NOT_CONNECT';
export const DELETED = 'DELETED';
export const CLOSED = 'CLOSED';

export const CLOSED_APPOINTMENT_STATUSES = [
  COMPLETED,
  CANCELED,
  COULD_NOT_CONNECT,
  DELETED,
];

export const AVAILABLE_CLOSED_APPOINTMENT_STATUSES = [
  COMPLETED,
  CANCELED,
  COULD_NOT_CONNECT,
];

export const appointmentEditableStatusMessagesMap = {
  [OPENED]: { id: 'Operations.AppointmentsList.ApptStatus.Open', defaultMessage: '** Open' },
  [CANCELED]: { id: 'Operations.AppointmentsList.ApptStatus.Closed', defaultMessage: '** Closed' },
};

export const appointmentEditableStateMessagesMap = {
  [ONGOING]: { id: 'General.Ongoing', defaultMessage: '** Ongoing' },
  [CANCELED]: { id: 'General.Canceled', defaultMessage: '** Canceled' },
  [COMPLETED]: { id: 'General.Completed', defaultMessage: '** Completed' },
  [COULD_NOT_CONNECT]: { id: 'General.CouldNotConnect', defaultMessage: '** Could not connect' },
};
